module.exports = __webpack_public_path__ + "img/logo-bold.48cfa4e6.gif";